<template>
  <a-popover :title="false">
    <template slot="content">
      <div class="p-all">{{ $t("Invert") }}</div>
    </template>

    <span
      class="tool-group-btn without-arrow"
      v-bind:class="{
        'tool-group-btn__active': invert,
      }"
    >
      <span class="tool-group-btn__item tool-group-btn__icon">
        <i class="fa-regular fa-circle-half-stroke" @click="updateInvert"> </i>
      </span>
    </span>
  </a-popover>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["invert"]),
  },
  created() {
    this.$accessModule("invert_tool", this);
  },
  methods: {
    updateInvert() {
      this.$store.dispatch("updateInvert", !this.invert);
    },
  },
};
</script>
